
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { Message } from 'element-ui'
import axios from 'axios';

function getImageBase64(image) {
  const canvas = document.createElement("canvas");
  canvas.width = image.width;
  canvas.height = image.height;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(image, 0, 0, image.width, image.height);
  // 获取图片后缀名
  const extension = image.src
    .substring(image.src.lastIndexOf(".") + 1)
    .toLowerCase();
  // 某些图片 url 可能没有后缀名，默认是 png
  return canvas.toDataURL("image/" + extension, 1);
}

/**
 * @param {Array} dataList  图片列表
 * @param {String} zipname  压缩包名称
 * @example see @/views/permission/directive.vue
 */
export async function downloadImages(dataList, zipname) {
  Message.success("素材加载打包压缩中，需要一点时间请稍后~");
  const zip = new JSZip();
  // const fileFolder = zip.folder(zipname); // 创建 zipName 文件夹
  const fileList = [];
  const nameCount = {};
  // winrar解压时，路径跟文件名总长度不能超过260个字符
  const MAX_LENGTH = 250;

  const truncate = (name) => {
    if (name.length <= MAX_LENGTH) return name;
    const dotIndex = name.lastIndexOf('.');
    if (dotIndex !== -1) {
      const base = name.substring(0, dotIndex);
      const ext = name.substring(dotIndex);
      const keepBaseLen = MAX_LENGTH - ext.length;
      if (keepBaseLen > 0) {
        return base.substring(0, keepBaseLen) + ext;
      }
    }
    return name.substring(0, MAX_LENGTH);
  }
  for (let i = 0; i < dataList.length; i++) {
    // const name = dataList[i].name; // 注意: 每张图片的名称--需要对数据属性进行转换
    let newName = truncate(dataList[i].name);
    let finalName = newName;
    if (nameCount[newName] !== undefined) {
      nameCount[newName]++;
      const dotIndex = newName.lastIndexOf('.');
      // 有扩展名的情况
      if (dotIndex !== -1) {
        const base = newName.substring(0, dotIndex);
        const ext = newName.substring(dotIndex);
        finalName = `${base} (${nameCount[newName]})${ext}`;
      } else {
        finalName = `${newName} (${nameCount[newName]})`;
      }
    } else {
      // 首次出现的名称计数0
      nameCount[newName] = 0;
    }
    await getBlob(dataList[i].url).then((blob) => {
      const file = new File([blob], finalName);
      zip.file(finalName, file);
    })

    // const image = new Image();
    // image.setAttribute("crossOrigin", "Anonymous"); // 设置 crossOrigin 属性，解决图片跨域报错
    // image.src = dataList[i].url;
    // image.onload = async () => {
    //   const url = await getImageBase64(image);
    //   fileList.push({
    //     name: name,
    //     img: url.substring(22),
    //   });
    //   if (fileList.length === dataList.length) {
    //     // this.loading = false;
    //     if (fileList.length) {
    //       for (let k = 0; k < fileList.length; k++) {
    //         fileFolder.file(fileList[k].name, fileList[k].img, {
    //           base64: true,
    //         });
    //       }
    //       zip.generateAsync({ type: "blob" }).then((content) => {
    //         saveAs(content, zipname + ".zip");
    //       });
    //     }
    //   }
    // };
  }
  zip.generateAsync({ type: "blob" }).then((content) => {
    saveAs(content, zipname + ".zip");
  });
}


/**
 * @param {Array} imgurl  图片链接
 * @param {String} name   名称
 * @example see @/views/permission/directive.vue
 */
function getBlob(url) {
  return new Promise((resolve) => {
    // const xhr = new XMLHttpRequest()
    // xhr.open('get', url, true)
    // xhr.responseType = 'blob'
    // xhr.onload = () => {
    //   if (xhr.status === 200) {
    //     res(xhr.response)
    //   }
    // }
    // xhr.send()
    // 图片太大时blob会报错
    axios({ url, responseType: 'arraybuffer' }).then(response => {
      const extension = url.substring(url.lastIndexOf(".") + 1).toLowerCase();
      const blob = new Blob([response.data], { type: 'image/' + extension });
      resolve(blob)
    })
  })
}

function selfSaveAs(blob, filename) {
  var link = document.createElement('a')
  link.href = window.URL.createObjectURL(blob)
  link.download = filename
  link.click();
}
export async function downloadSingleImage(imgurl, name) {
  // var image = new Image();
  // image.setAttribute("crossOrigin", "anonymous");
  // image.onload = function () {
  //   var canvas = document.createElement("canvas");
  //   canvas.width = image.width;
  //   canvas.height = image.height;
  //   var context = canvas.getContext("2d");
  //   context.drawImage(image, 0, 0, image.width, image.height);
  //   var url = canvas.toDataURL("image/png");
  // var a = document.createElement("a");
  // var event = new MouseEvent("click");
  // a.download = name || "image";
  // a.href = imgurl;
  // a.dispatchEvent(event);
  // a.remove();
  // };
  // image.src = imgurl;
  getBlob(imgurl).then((blob) => {
    selfSaveAs(blob, name)
  })
}


/**
 * @param {Array} dataList  文件列表
 * @param {String} zipname  压缩包名称
 * @example see @/views/permission/directive.vue
 */
export async function downloadToZip(dataList, zipname) {
  Message.success("打包压缩中，需要一点时间请稍后~");
  const zip = new JSZip();
  // const fileFolder = zip.folder(zipname); // 创建 zipName 文件夹

  const downloadPromises = dataList.map(async (data, index) => {
    const response = await axios.get(data.url, { responseType: 'blob' });
    zip.file(data.name, response.data); // 直接添加 Blob（Excel 数据）
  });

  try {
    await Promise.all(downloadPromises);
    const zipBlob = await zip.generateAsync({ type: 'blob' });
    saveAs(zipBlob, zipname); // 下载 ZIP
  } catch (error) {
    Message.error("打包失败");
  }
  // const fileList = [];
  // for (let i = 0; i < dataList.length; i++) {
  //   const name = dataList[i].name; // 注意: 每张图片的名称--需要对数据属性进行转换
  //   fileList.push({
  //     name: name,
  //     url: dataList[i].url,
  //   });
  //   if (fileList.length === dataList.length) {
  //     // this.loading = false;
  //     if (fileList.length) {
  //       for (let k = 0; k < fileList.length; k++) {
  //         fileFolder.file(fileList[k].name, fileList[k].url);
  //       }
  //       zip.generateAsync({ type: "blob" }).then((content) => {
  //         saveAs(content, zipname + ".zip");
  //       });
  //     }
  //   }
  // }
}

